<header>

    <div id="header" class="header">

  
        <div class="header-left"> 
            <a href="#" (click)="navigate('')">
                <img 
                    class="header-left-logo" src="assets/logos/Logo_ARTIS_Opacity.svg" 
                    alt="{{this.languageService.Strings.alts.logo_artis}}" oncontextmenu="return false;" draggable="false"/>
            </a>
        </div>

        <!-- Language -->
        <div class="header-right">
            <button class="mat-button-custom" (click)="changeLanguage()">
                <img class="mat-button-custom-image" src="{{this.languageService.languageFlag}}" alt="" oncontextmenu="return false;" draggable="false"/>
                {{this.languageService.languageString}}
            </button>
        </div>

        
        <!-- Midel buttons -->
        <div class="header-mid">
            <button class="button-custom custom-font-family" (click)="navigate('software')">{{languageService.Strings.headerStrings.button_software}}</button> 
            <button class="button-custom custom-font-family" (click)="navigate('contact')">{{languageService.Strings.headerStrings.button_contact}}</button>
        </div>

        <!-- Mobile right menu -->
        <div class="header-menu-right">
            <button class="mat-button-custom-mobile" [matMenuTriggerFor]="mobileBarMenu">
                <mat-icon>menu</mat-icon>
            </button>
        </div>
        <mat-menu #mobileBarMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="navigate('software')">
                <button mat-menu-item class="menu-item-mobile">
                    {{this.languageService.Strings.headerStrings.button_software}}
                </button>
            </button>
            <button mat-menu-item (click)="navigate('contact')">
                <button mat-menu-item class="menu-item-mobile">
                    {{this.languageService.Strings.headerStrings.button_contact}}
                </button>
            </button>
            <button mat-menu-item (click)="changeLanguage()">
                <button mat-menu-item class="menu-item-mobile">
                    <img class="mat-button-custom-image-mobile" src="{{this.languageService.languageFlag}}" alt="" oncontextmenu="return false;" draggable="false"/>
                    {{this.languageService.languageString}}
                </button>
            </button>
        </mat-menu>
        
    </div>
    
</header>
